import React from 'react';
import { Form } from 'react-bootstrap';
import { extractFillInAcceptedAnswers, isFillInAnswerCorrect } from '@utils/fillInAnswerMatching';

/**
 * Fill-in-the-Blank Question Component
 */
export function FillInQuestion({ question, value, onChange, disabled = false, showCorrect = false }) {
  const acceptedAnswers = extractFillInAcceptedAnswers(question?.correctAnswer);
  const isCorrect = showCorrect && isFillInAnswerCorrect(value, question?.correctAnswer);
  const isIncorrect = showCorrect && value && !isCorrect;

  return (
    <div className="fill-in-question">
      <Form.Group>
        <Form.Control
          type="text"
          placeholder="Type your answer here..."
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          className={showCorrect ? (isCorrect ? 'is-valid' : isIncorrect ? 'is-invalid' : '') : ''}
        />
        {showCorrect && isCorrect && (
          <Form.Control.Feedback type="valid">
            Correct!
          </Form.Control.Feedback>
        )}
        {showCorrect && isIncorrect && (
          <Form.Control.Feedback type="invalid">
            Incorrect. Accepted answer{acceptedAnswers.length === 1 ? '' : 's'}: {acceptedAnswers.join(', ') || 'not provided'}
          </Form.Control.Feedback>
        )}
      </Form.Group>
    </div>
  );
}
